import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSlider2 from "../components/Slider/CardSlider2";
import RoiCTA from "../components/CTA/RoiCTA";
import FeaturedContent from "../components/Featured/FeaturedContent";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import { useModal } from "../context/ModalContext";
import FAQs from "../components/FAQ/FAQs";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";

const faqData = [
  {
    question: "What is Shoora's Cabin Vision, and how does it work?",
    answer:
      "Shoora's Cabin Vision is an advanced driver monitoring solution that uses AI-powered DSM cameras and internet-connected dashcams to track driver behavior in real-time. It provides instant alerts for risky behaviors, enabling proactive safety coaching and minimizing risks.",
  },
  {
    question: "What types of risky behaviors can Shoora's Cabin Vision detect?",
    answer:
      "Shoora's Cabin Vision can detect a range of risky behaviors, including driver fatigue, distraction, phone use, smoking, yawning, and failure to wear a seatbelt.",
  },
  {
    question:
      "How does Shoora's Cabin Vision provide evidence in case of an incident?",
    answer:
      "Shoora's Cabin Vision provides crystal-clear video footage from its internet-connected dashcams, which can be retrieved instantly for accident reconstruction or compliance purposes. This on-demand video access helps eliminate ambiguity in incidents and reduces liability.",
  },
  {
    question:
      "Is Shoora's Cabin Vision easy to implement, and how does it support drivers?",
    answer:
      "Yes, Shoora's Cabin Vision has a plug-and-play design, making it easy to implement within minutes. It also provides two-way communication with Shoora's 24/7 Control Room, supporting drivers during emergencies or alerts and reinforcing driver confidence.",
  },
  {
    question:
      "What benefits can fleet operators expect from using Shoora's Cabin Vision?",
    answer:
      "Fleet operators can expect several benefits from using Shoora's Cabin Vision, including proactive risk mitigation, improved driver safety, reduced liability, enhanced fleet performance, and long-term ROI.",
  },
  {
    question:
      "How can Shoora's Cabin Vision be integrated into fleet management processes?",
    answer:
      "Shoora's Cabin Vision can be integrated into fleet management processes in several ways, including: 1) Driver training and coaching, 2) Fleet performance monitoring, 3) Driver safety analysis, 4) Incident response, and 5) Enhanced fleet management and safety.",
  },
];

const cabinvisionfeatures = [
  {
    id: 1,
    category: "Feature",
    title: "Internet-Connected Dashcams",
    description:
      "Advanced driver-facing AI dash cams with up to 2K (1440p) resolution for crystal-clear monitoring.",
    image: "/images/features/1.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 2,
    category: "Feature",
    title: "Address Unsafe Driving Habits",
    description:
      "Real-time AI technology identifies risky behaviours, including fatigue, distraction, smoking, phone use, yawning, and failure to wear a seatbelt, promoting safer driving.",
    image: "/images/features/2.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 3,
    category: "Feature",
    title: "On-Demand Video Access",
    description:
      "Retrieve event footage over the air for instant reconstruction and analysis when needed.",
    image: "/images/features/3.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 4,
    category: "Feature",
    title: "Effortless Setup",
    description:
      "Plug-and-play design ensures your dashcam is up and running in just minutes, without requiring additional setup or maintenance.",
    image: "/images/features/4.png",
    // link: "#",
    // linkText: "Read more",
  },
];

const CabInVision = () => {
  const { openModal } = useModal();
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "CabInVision™",
    image: "/images/products/cabin-vision1.webp",
    description:
      "CabInVision™ is an advanced AI-powered driver monitoring solution that enhances fleet safety by tracking real-time driver behavior.",
    brand: {
      "@type": "Brand",
      name: "Shoora",
    },
    offers: {
      "@type": "Offer",
      priceCurrency: "USD",
      price: "Contact Us for Pricing",
      availability: "https://schema.org/InStock",
      url: "https://www.shoora.com/cabinvision",
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "AI Driver Monitoring",
        value: "Real-time behavior tracking",
      },
      {
        "@type": "PropertyValue",
        name: "Internet-Connected Dashcams",
        value: "Crystal-clear 2K video",
      },
      {
        "@type": "PropertyValue",
        name: "Proactive Risk Mitigation",
        value: "Instant alerts and support",
      },
    ],
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <Page
      title="CabInVision™: Advanced AI Driver Monitoring Solution for Safer Roads"
      description="Discover CabInVision™ by Shoora – an AI-driven driver monitoring solution featuring advanced dashcams, real-time behavior analysis, and proactive risk mitigation. Ensure safety, reduce liability, and enhance fleet performance effortlessly."
      keywords="CabInVision, AI Driver Monitoring, Advanced Dashcams, Fleet Safety, Driver Behavior Analysis, Proactive Risk Mitigation, Driver Fatigue Detection, Internet-Connected Dashcams, Fleet Performance, Driver Safety"
      structuredData={structuredData}
    >
      {/* <div
        className="about-hero w-100">
        <img
          src="/images/products/cabin-vision1.webp"
          alt=""
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div
            className="col col-12 col-lg-6 px-5"
            style={{ backgroundColor: "#ffff00b0" }}
          >
            <p className="fs-1 text-light mb-5"></p>
            <h1 className="text-dark fw-bold mb-4">
              2-Channel and 3-Channel ADAS DSM System
            </h1>
            <p className="fs-5 text mb-5">
              Advanced driver monitoring solution that continuously tracks
              driver behaviour in real-time.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-dark rounded-5" onClick={openModal}>
                See Plans & Pricing
              </button>
              <Link className="ms-3 btn btn-link text-dark fw-bold text-decoration-none">
                Get a Demo
              </Link>
            </div>
          </div>
        </div>
      </div> */}
      <div className="about-hero hero-2 w-100">
        <img
          src="/images/products/cabin-vision1.webp"
          alt="Shoora Cabin Vision Hero"
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-8 pe-lg-5">
            <p
              className="fs-6 text-white mt-4"
              style={{ lineHeight: 0.5, marginBottom: "0px !important" }}
            >
              {/* Stay protected with */}
            </p>
            <h1
              className="text-accent fw-bold mb-4 display-3"
              style={{ lineHeight: 0.9, marginBottom: "0px !important" }}
            >
              2-Channel and 3-Channel DSM System
            </h1>
            {/* <p className="fs-5  text-accent">Your Safety, Our Priority.</p> */}
            <p className="fs-6 text-light mb-5 pe-5">
              Advanced driver monitoring solution that continuously tracks
              driver behaviour in real-time.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-light rounded-5" onClick={openModal}>
                Get Started Today
              </button>
              <a
                className="ms-3 btn btn-link text-light fw-bold text-decoration-none"
                onClick={openModal}
                href="#cta"
              >
                Get a Demo
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <RoiCTA /> */}
      {/* Navigation Bar */}
      <div className="container-fluid bg-black sticky-top d-none d-lg-block">
        <div className="container nav-links">
          <ul className="navigation-group">
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("overview")}
                className="navigation-item-link btn btn-link text-white"
              >
                Overview
              </button>
            </li>

            <li className="navigation-item">
              <button
                onClick={() => handleScroll("features")}
                className="navigation-item-link btn btn-link text-white"
              >
                Features
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("benefits")}
                className="navigation-item-link btn btn-link text-white"
              >
                Benefits
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("testimonials")}
                className="navigation-item-link btn btn-link text-white"
              >
                Testimonials
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("faqs")}
                className="navigation-item-link btn btn-link text-white"
              >
                FAQs
              </button>
            </li>
          </ul>
        </div>
      </div>

      <section id="overview" className="container">
        <div className="row align-items-center">
          <div className="col col-12 col-lg-6 ps-lg-5">
            <h6 className="fs-bold text-accent">Overview</h6>
            <h1 className="mb-4">
              Ensure that drivers adopt safer driving habits through our Control
              Room
            </h1>
            <p className="mb-5">
              When an alert is triggered, our team instantly connects with the
              driver via the in-vehicle two-way communication system, ensuring
              rapid resolution of issues and minimising risks or delays.
            </p>
          </div>
          <div className="col">
            <video
              height={450}
              width={800}
              autoPlay
              loop
              muted
              className="w-100 pt-5 p-lg-0 pe-0"
            >
              <source
                src="/videos/products/cabin-vision1.mp4"
                type="video/mp4"
              ></source>
            </video>
          </div>
        </div>
      </section>

      {/* <div className="container">
        <div className="row align-items-center">
          <div className="col col-12">
            <h6 className="fs-bold text-accent">CabInVision</h6>
            <h1 className="mb-4">
              Ensure that drivers adopt safer driving habits through our Control
              Room
            </h1>
            <p className="mb-5">
              When an alert is triggered, our team instantly connects with the
              driver via the in-vehicle two-way communication system, ensuring
              rapid resolution of issues and minimising risks or delays.
            </p>
          </div>
         
        </div>
      </div> */}

      <section id="features" className="my-5">
        <div className="container">
          <div className="section-header">
            <h2>CabIn Vision makes road safer</h2>
          </div>
        </div>
        <CardSlider2 data={cabinvisionfeatures} />
      </section>

      <section id="benefits">
        <CardContainer
          heading="Benefits"
          desc="Discover how this solution drives business success while making roads safer."
        >
          <Card
            // category="Safety"
            bgColor="#f4f4f4"
            type="primary"
            headingColor="#0d004a"
            heading="Proactive Risk Mitigation"
            desc="CabIn Vision™ uses AI-driven DSM technology to monitor drivers in real-time, alerting operators to risky behaviors like fatigue and distractions. It enhances safety, prevents accidents, reduces disruptions, and fosters accountability, creating safer, more responsible drivers."
            imgsrc="/images/benefits/2.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Crystal-Clear Monitoring and Evidence Access"
            desc="CabIn Vision™ dashcams with 2K resolution provide clear footage, enabling instant event analysis, reducing liability, resolving disputes, ensuring compliance, and saving time while protecting fleet resources."
            imgsrc="/images/benefits/1.png"
          />
          <Card
            //   category="Coaching insights"
            type="primary"
            heading="Seamless Integration and Driver Engagement"
            desc="CabIn Vision™ offers quick plug-and-play setup and 24/7 support via Shoora’s Control Room. Two-way communication boosts driver confidence, while advanced coaching improves safety, reduces risks, and enhances fleet performance for long-term ROI."
            imgsrc="/images/benefits/3.png"
            // linkText="See Plans & Pricing"
          />
        </CardContainer>
      </section>

      <section id="testimonials" className="testimonials-section section">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      <FeaturedContent />

      <section id="faqs">
        <FAQs
          data={faqData}
          title="Your questions about CabInVision™, answered."
        />
      </section>
    </Page>
  );
};

export default CabInVision;
